import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentCarousel from '../content-carousel/ContentCarousel';
import ContentPic from '../content-pic/ContentPic';
import ContentVideo from '../content-video/ContentVideo';

class ContentPics extends Component {
  static propTypes = {
    pics: PropTypes.array.isRequired,
  };

  render() {
    const { pics } = this.props;
    const rows = pics.map((pic, idx) => {
      const { carousel } = pic;
      if (carousel) {
        return <ContentCarousel key={idx} pic={pic} />;
      } else {
        return pic.attachments.map((attachment, idx) => {
          const { url, type } = attachment;

          if (type === 'video/mp4') {
            return <ContentVideo pic={pic} url={url} key={idx} />;
          } else {
            return <ContentPic pic={pic} url={url} key={idx} />;
          }
        });
      }
    });

    return (
      <section className='container'>{rows}</section>
    );
  }
}

export default ContentPics;



// WEBPACK FOOTER //
// ./src/components/content-pics/ContentPics.js